'use es6';

import { listOf } from 'react-immutable-proptypes';
import { useMemo } from 'react';
import { useFetchResolver } from 'reference-resolvers-lite/ResolverHooks';
import FilterOperatorType from 'customer-data-filters/components/propTypes/FilterOperatorType';
import PropTypes from 'prop-types';
import PropertyOptionRecord from 'customer-data-objects/property/PropertyOptionRecord';
import { jsx as _jsx } from "react/jsx-runtime";
const DisplayValueExternalOption = props => {
  const {
    getFamilyValueResolver,
    operator,
    specialOptions,
    value
  } = props;
  const resolver = getFamilyValueResolver(operator);
  const {
    reference
  } = useFetchResolver(resolver, value);
  const resolvedValue = useMemo(() => {
    if (specialOptions) {
      const specialValue = specialOptions.findLast(option => option.value === value);
      if (specialValue) {
        return specialValue.label || specialValue.value;
      }
    }
    if (reference) {
      return reference.label || reference.id;
    }
    return value;
  }, [reference, specialOptions, value]);
  return /*#__PURE__*/_jsx("span", {
    children: resolvedValue
  });
};
DisplayValueExternalOption.propTypes = {
  getFamilyValueResolver: PropTypes.func.isRequired,
  operator: FilterOperatorType.isRequired,
  specialOptions: listOf(PropTypes.instanceOf(PropertyOptionRecord).isRequired),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
export default DisplayValueExternalOption;